/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatSystemMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKSystemMessageHandler = function() {
	this.constructor.__super__.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_SYSTEM);
};

$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,com.inq.flash.client.control.messagehandlers.CMSDKSystemMessageHandler,"com.inq.flash.client.control.messagehandlers.CMSDKSystemMessageHandler")


com.inq.flash.client.control.messagehandlers.CMSDKSystemMessageHandler.prototype.processMessage = function(message) {
	this.controller.onNewChatRouterMessage(message);
};

